<script lang="ts">
    import type { DataFormat } from '../types';
    import { DATA_FORMAT } from '../constants';

    export let dataFormat: DataFormat | undefined;

    const TEXT = `<path fill-rule="evenodd" clip-rule="evenodd"
            d="M12.0059 10.2051C12.3704 9.71287 12.8512 9.4668 13.4482 9.4668C14.2686 9.46681 14.8701
            9.76532 15.2529 10.3623C15.6357 10.9548 15.8317 11.8252 15.8408 12.9736V13.541C15.8408 14.7396
            15.6494 15.6396 15.2666 16.2412C14.8838 16.8382 14.2822 17.1367 13.4619 17.1367C12.8193 17.1367
            12.3044 16.8473 11.917 16.2686L11.8555 17H10.0713V6.5H12.0059V10.2051ZM12.8945 11.0869C12.4889
            11.0869 12.1927 11.2715 12.0059 11.6406V15.0107C12.179 15.3571 12.4798 15.5303 12.9082 15.5303C13.2773
            15.5303 13.5326 15.4095 13.6738 15.168C13.8197 14.9264 13.8972 14.4569 13.9062 13.7598V13.0557C13.9062
            12.2764 13.8311 11.7546 13.6807 11.4902C13.5303 11.2214 13.2682 11.0869 12.8945 11.0869Z"
        /><path
            d="M19.7031 9.4668C20.5189 9.4668 21.1615 9.71974 21.6309 10.2256C22.1003 10.7269 22.3395
            11.4401 22.3486 12.3652H20.5303C20.5257 11.9505 20.4574 11.6315 20.3252 11.4082C20.193 11.1849
            19.9743 11.0733 19.6689 11.0732C19.3317 11.0732 19.0902 11.194 18.9443 11.4355C18.7985 11.6726
            18.721 12.1352 18.7119 12.8232V13.5752C18.7119 14.1768 18.7415 14.5983 18.8008 14.8398C18.86
            15.0768 18.958 15.2523 19.0947 15.3662C19.2314 15.4756 19.4251 15.5303 19.6758 15.5303C20.2363
            15.5303 20.5212 15.1657 20.5303 14.4365H22.3486C22.3395 15.2432 22.0911 15.8949 21.6035 16.3916C21.1159
            16.8883 20.487 17.1367 19.7168 17.1367C18.7643 17.1367 18.0374 16.8405 17.5361 16.248C17.0348
            15.6556 16.7796 14.7829 16.7705 13.6299V13.042C16.7705 11.8799 17.0166 10.9935 17.5088 10.3828C18.0055
            9.77215 18.737 9.4668 19.7031 9.4668Z"
        /><path fill-rule="evenodd" clip-rule="evenodd"
            d="M9.23047 17H7.08398L6.55078 14.9629H3.80957L3.27637 17H1.15039L4.26074 7.04688H6.09961L9.23047
            17ZM4.24707 13.2881H6.10645L5.17676 9.74023L4.24707 13.2881Z"
        />`;

    const paths: Partial<Record<DataFormat, string>> = {
        // abc-custom (Figma)
        [DATA_FORMAT.shortText]: TEXT,
        [DATA_FORMAT.longText]: TEXT,
        // map-pin-2-line (Figma)
        [DATA_FORMAT.geo]: `<path
            d="M12 23.728L5.636 17.364C4.37734 16.1054 3.52019 14.5017 3.17293 12.7559C2.82567 11.0101
            3.00391 9.20047 3.6851 7.55595C4.36629 5.91142 5.51984 4.50582 6.99988 3.51689C8.47992 2.52796
            10.22 2.00012 12 2.00012C13.78 2.00012 15.5201 2.52796 17.0001 3.51689C18.4802 4.50582
            19.6337 5.91142 20.3149 7.55595C20.9961 9.20047 21.1743 11.0101 20.8271 12.7559C20.4798
            14.5017 19.6227 16.1054 18.364 17.364L12 23.728ZM16.95 15.95C17.9289 14.971 18.5955 13.7238
            18.8656 12.3659C19.1356 11.0081 18.9969 9.60064 18.4671 8.3216C17.9373 7.04256 17.04 5.94935
            15.8889 5.18021C14.7378 4.41107 13.3844 4.00055 12 4.00055C10.6156 4.00055 9.26222 4.41107
            8.11109 5.18021C6.95996 5.94935 6.06275 7.04256 5.53292 8.3216C5.00308 9.60064 4.86442 11.0081
            5.13445 12.3659C5.40449 13.7238 6.07111 14.971 7.05 15.95L12 20.9L16.95 15.95ZM12 13C11.4696
            13 10.9609 12.7893 10.5858 12.4143C10.2107 12.0392 10 11.5305 10 11C10 10.4696 10.2107 9.9609
            10.5858 9.58583C10.9609 9.21076 11.4696 9.00004 12 9.00004C12.5304 9.00004 13.0391 9.21076
            13.4142 9.58583C13.7893 9.9609 14 10.4696 14 11C14 11.5305 13.7893 12.0392 13.4142 12.4143C13.0391
            12.7893 12.5304 13 12 13Z"
        />`,
        // calendar-2-line (Figma)
        [DATA_FORMAT.date]: `<path
            d="M17 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22
            20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043
            20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289
            3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9V3H15V1H17V3ZM20 11H4V19H20V11ZM15 5H9V7H7V5H4V9H20V5H17V7H15
            V5ZM6 13H8V15H6V13ZM11 13H13V15H11V13ZM16 13H18V15H16V13Z"
        />`,
        // 123-custom (Figma)
        [DATA_FORMAT.number]: `<path
            d="M18.4336 7C19.3496 7 20.0674 7.25293 20.5869 7.75879C21.1064 8.26465 21.3662 8.95737
            21.3662 9.83691C21.3662 10.2881 21.2477 10.7074 21.0107 11.0947C20.7783 11.4775 20.4707
            11.7715 20.0879 11.9766C20.5573 12.1771 20.9059 12.4779 21.1338 12.8789C21.3662 13.2799
            21.4824 13.7539 21.4824 14.3008C21.4824 15.1849 21.1999 15.8936 20.6348 16.4268C20.0742 16.96
            19.3359 17.2266 18.4199 17.2266C17.5677 17.2266 16.875 16.9645 16.3418 16.4404C15.8132 15.9118
            15.5488 15.2191 15.5488 14.3623H17.4834C17.4834 14.7178 17.5768 15.0163 17.7637 15.2578C17.9505
            15.4993 18.1875 15.6201 18.4746 15.6201C18.8073 15.6201 19.0693 15.4971 19.2607 15.251C19.4567
            15.0049 19.5547 14.6768 19.5547 14.2666C19.5547 13.2868 19.1742 12.7946 18.4131 12.79
            H17.4629V11.2314H18.3994C18.7549 11.2314 19.0146 11.1084 19.1787 10.8623C19.3473 10.6117
            19.4316 10.279 19.4316 9.86426C19.4316
            9.46777 19.3451 9.16016 19.1719 8.94141C19.0033 8.7181 18.7754 8.60645 18.4883 8.60645C18.2194
            8.60645 17.9984 8.71126 17.8252 8.9209C17.6566 9.13053 17.5723 9.39486 17.5723 9.71387H15.6377C15.6377
            9.19434 15.7562 8.72948 15.9932 8.31934C16.2347 7.90462 16.5697 7.58105 16.998 7.34863C17.431
            7.11623 17.9095 7 18.4336 7Z"
        /><path d="M5.83496 17.0898H3.89355V9.48828L2 10.2197V8.60645L5.62988 7.12305H5.83496V17.0898Z"
        /><path
            d="M11.4951 7C12.3838 7 13.0719 7.2461 13.5596 7.73828C14.0518 8.22591 14.2979 8.9209
            14.2979 9.82324C14.2979 10.3838 14.1611 10.9535 13.8877 11.5322C13.6188 12.1064 13.1289
            12.8151 12.418 13.6582L11.1396 15.4834H14.5234V17.0898H8.6582V15.7227L11.3516 12.2979C11.6934
            11.8239 11.944 11.4092 12.1035 11.0537C12.2676 10.6937 12.3496 10.3496 12.3496 10.0215C12.3496
            9.57942 12.2721 9.23307 12.1172 8.98242C11.9668 8.73179 11.748 8.60646 11.4609 8.60645C11.1465
            8.60645 10.8958 8.75228 10.709 9.04395C10.5267 9.33561 10.4355 9.74579 10.4355 10.2744H8.49414C8.49414
            9.66375 8.61947 9.10547 8.87012 8.59961C9.12533 8.09375 9.48079 7.70182 9.93652 7.42383C10.3968
            7.14128 10.9163 7 11.4951 7Z"
        />`,
        // boolean-custom (Figma)
        [DATA_FORMAT.boolean]: `<path d="M3.536 12.535L7.071 9L8.486 10.414L3.536 15.364L0 11.828L1.415 10.414L3.536 12.535Z"
        /><path
            d="M20.536 10.122L22.657 8L24.072 9.415L21.95 11.536L24.072 13.657L22.657 15.072L20.536
            12.95L18.415 15.072L17 13.657L19.122 11.536L17 9.415L18.415 8L20.536 10.122Z"
        /><path fill-rule="evenodd" clip-rule="evenodd" d="M13 4V20H11V4H13Z" />`,
        // links-line (Figma)
        [DATA_FORMAT.url]: `<path
            d="M18.3638 15.536L16.9498 14.12L18.3638 12.706C18.8314 12.2424 19.2029 11.6911 19.4568 11.0836
            C19.7108 10.4761 19.8423 9.8244 19.8437 9.16595C19.8452 8.5075 19.7166 7.85525 19.4652 7.24665
            C19.2139 6.63804 18.8449 6.08507 18.3793 5.61947C17.9137 5.15387 17.3607 4.78483 16.7521 4.53351
            C16.1435 4.2822 15.4913 4.15357 14.8328 4.15502C14.1744 4.15646 13.5227 4.28794 12.9152 4.54192
            C12.3077 4.79589 11.7563 5.16736 11.2928 5.63499L9.87877 7.04999L8.46377 5.63599L9.87977 4.22199
            C11.1926 2.90917 12.9732 2.17163 14.8298 2.17163C16.6864 2.17163 18.4669 2.90917 19.7798 4.22199
            C21.0926 5.53481 21.8301 7.31538 21.8301 9.17199C21.8301 11.0286 21.0926 12.8092 19.7798 14.122
            L18.3648 15.536H18.3638ZM15.5358 18.364L14.1208 19.778C12.8079 21.0908 11.0274 21.8283 9.17077 21.8283
            C7.31416 21.8283 5.53359 21.0908 4.22077 19.778C2.90795 18.4652 2.17041 16.6846 2.17041 14.828
            C2.17041 12.9714 2.90795 11.1908 4.22077 9.87799L5.63577 8.46399L7.04977 9.87999L5.63577 11.294
            C5.16814 11.7575 4.79667 12.3089 4.5427 12.9164C4.28872 13.5239 4.15724 14.1756 4.1558 14.834
            C4.15435 15.4925 4.28298 16.1447 4.53429 16.7533C4.78561 17.3619 5.15465 17.9149 5.62025 18.3805
            C6.08585 18.8461 6.63882 19.2152 7.24743 19.4665C7.85603 19.7178 8.50828 19.8464 9.16673 19.845
            C9.82518 19.8435 10.4769 19.712 11.0844 19.4581C11.6919 19.2041 12.2432 18.8326 12.7068 18.365
            L14.1208 16.951L15.5358 18.365V18.364ZM14.8278 7.75699L16.2428 9.17199L9.17177 16.242L7.75677 14.828
            L14.8278 7.75799V7.75699Z"
        />`,
        // braces-fill (Figma)
        [DATA_FORMAT.json]: `<path
            d="M4 18V14.3C4 13.4716 3.32843 12.8 2.5 12.8H2V11.2H2.5C3.32843 11.2 4 10.5284 4 9.7V6C4 4.34315
            5.34315 3 7 3H8V5H7C6.44772 5 6 5.44772 6 6V10.1C6 10.9858 5.42408 11.7372 4.62623 12C5.42408
            12.2628 6 13.0142 6 13.9V18C6 18.5523 6.44772 19 7 19H8V21H7C5.34315 21 4 19.6569 4 18ZM20 14.3V18C20
            19.6569 18.6569 21 17 21H16V19H17C17.5523 19 18 18.5523 18 18V13.9C18 13.0142 18.5759 12.2628 19.3738
            12C18.5759 11.7372 18 10.9858 18 10.1V6C18 5.44772 17.5523 5 17 5H16V3H17C18.6569 3 20 4.34315 20 6V9.7C20
            10.5284 20.6716 11.2 21.5 11.2H22V12.8H21.5C20.6716 12.8 20 13.4716 20 14.3Z"
        />`,
        // file-line (Figma)
        [DATA_FORMAT.file]: `<path
            d="M9.00002 2.003V2H19.998C20.55 2 21 2.455 21 2.992V21.008C20.9998 21.2712 20.895 21.5235
            20.7088 21.7095C20.5226 21.8955 20.2702 22 20.007 22H3.99302C3.8617 21.9991 3.73185 21.9723
            3.61087 21.9212C3.48989 21.8701 3.38017 21.7957 3.28796 21.7022C3.19575 21.6087 3.12286 21.4979
            3.07346 21.3762C3.02406 21.2545 2.9991 21.1243 3.00002 20.993V8L9.00002 2.003ZM5.83002 8H9.00002V4.83
            L5.83002 8ZM11 4V9C11 9.26522 10.8947 9.51957 10.7071 9.70711C10.5196 9.89464 10.2652 10
            10 10H5.00002V20H19V4H11Z"
        />`,
        // image-line (Figma)
        [DATA_FORMAT.image]: `<path
            d="M4.828 21L4.808 21.02L4.787 21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448
            20.5226 2 20.2702 2 20.007V3.993C2.00183 3.73038 2.1069 3.47902 2.29251 3.29322C2.47813 3.10742
            2.72938 3.00209 2.992 3H21.008C21.556 3 22 3.445 22 3.993V20.007C21.9982 20.2696 21.8931 20.521
            21.7075 20.7068C21.5219 20.8926 21.2706 20.9979 21.008 21H4.828ZM20 15V5H4V19L14 9L20 15ZM20
            17.828L14 11.828L6.828 19H20V17.828ZM8 11C7.46957 11 6.96086 10.7893 6.58579 10.4142C6.21071
            10.0391 6 9.53043 6 9C6 8.46957 6.21071 7.96086 6.58579 7.58579C6.96086 7.21071 7.46957 7 8
            7C8.53043 7 9.03914 7.21071 9.41421 7.58579C9.78929 7.96086 10 8.46957 10 9C10 9.53043 9.78929
            10.0391 9.41421 10.4142C9.03914 10.7893 8.53043 11 8 11Z"
        />`,
        // ip-address-custom (Figma)
        [DATA_FORMAT.ipAddress]: `<path d="M7 6H9V18H7V6Z"
        /><path fill-rule="evenodd" clip-rule="evenodd"
            d="M11 6H13C15.2091 6 17 7.79086 17 10C17 12.2091 15.2091 14 13 14V18H11V6ZM13 12C14.1046 12
            15 11.1046 15 10C15 8.89543 14.1046 8 13 8V12Z"
        />`,
        // id-custom (Figma)
        [DATA_FORMAT.id]: `<path d="M7 6H9V18H7V6Z"
        /><path fill-rule="evenodd" clip-rule="evenodd"
            d="M11 6H13C16.3137 6 19 8.68629 19 12C19 15.3137 16.3137 18 13 18H11V6ZM13 8V16C15.2091 16
            17 14.2091 17 12C17 9.79086 15.2091 8 13 8Z"
        />`,
    };

    // question-custom (Figma) — fallback for unknown/undefined types
    const UNKNOWN = `<path d="M13.433 15.5011H11.433V17.5011H13.433V15.5011Z" /><path d="M13.433 14.5011V12.8561C14.0271 12.679 14.5636 12.3473 14.9875 11.895C15.4115 11.4426 15.7077 10.8858 15.8459 10.2814C15.9841 9.67703 15.9593 9.04685 15.7741 8.45519C15.5889 7.86354 15.2499 7.33167 14.7918 6.91395C14.3337 6.49624 13.7729 6.20767 13.1667 6.07774C12.5605 5.94782 11.9307 5.98119 11.3416 6.17445C10.7525 6.36771 10.2253 6.71393 9.81392 7.17772C9.40251 7.6415 9.12163 8.20621 9 8.81413L10.962 9.20713C11.0177 8.92856 11.1513 8.67153 11.3474 8.46595C11.5434 8.26036 11.7938 8.11467 12.0694 8.04584C12.345 7.977 12.6345 7.98784 12.9042 8.0771C13.1739 8.16636 13.4127 8.33037 13.5928 8.55004C13.773 8.76971 13.887 9.03602 13.9217 9.31797C13.9564 9.59993 13.9103 9.88593 13.7888 10.1427C13.6673 10.3995 13.4753 10.6165 13.2353 10.7684C12.9953 10.9204 12.7171 11.0011 12.433 11.0011C12.1678 11.0011 11.9134 11.1065 11.7259 11.294C11.5384 11.4815 11.433 11.7359 11.433 12.0011V14.5011H13.433Z" />`;

    $: icon = (dataFormat && paths[dataFormat]) ?? UNKNOWN;
</script>

<svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
>
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html icon}
</svg>

<style>
    svg {
        flex-shrink: 0;
    }
</style>
